import PropTypes from "prop-types"
import RiskCategory from "./components/category"
import "./style.scss"

function RiskDetails({ riskDetails, max, openFactorProfile, hasAggregatedFactors }) {
  return <div className="modules_risk-details">
    <div className="headers">
      <div className="exposure">Portfolio Exposure</div>
      {!hasAggregatedFactors && <div className="volatility">Factor Volatility</div>}
    </div>
    {riskDetails.map(category => <RiskCategory key={category.id} {...category} {...{ max, openFactorProfile, displayVolatility: !hasAggregatedFactors }} />)}
  </div>
}

RiskDetails.propTypes = {
  riskDetails: PropTypes.array.isRequired,
  max: PropTypes.number.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  hasAggregatedFactors: PropTypes.bool.isRequired,
}

export default RiskDetails
